
export type GetNotifications200NotificationsItemStatus = {
  isRead: boolean;
};
